const Trashbin = (props) => {
  return (
    <svg
      viewBox="0 0 12 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.25 1H8.625l-.75-.75h-3.75l-.75.75H.75v1.5h10.5V1ZM1.5 3.25v9c0 .825.675 1.5 1.5 1.5h6c.825 0 1.5-.675 1.5-1.5v-9h-9Zm6 5.25v3h-3v-3H3l3-3 3 3H7.5Z"
        fill="#0F2962"
      />
    </svg>
  )
}
 
export default Trashbin